import React from 'react';
import { connect } from 'react-redux';
import { Dispatch } from 'redux';
import classNames from 'classnames';

import { RootState } from '../../reducers';
import * as actions from '../../actions/';
import './ExpandableRow.scss';
import { defined } from '../../utils/variableEvaluation';
import { KitIcons } from '@repo/apg-ui';

interface Props {
  title: string;
  subtitle: string;
  moreContent: any;
  rowChanged?: any;
  className?: string;
  expanded?: number;
  index?: number;
  length?: number;
  answers?: any;
  boldAnswers?: string;
  answers2?: any;
  answers3?: any;
  answers4?: any;
  answers5?: any;
  answers6?: any;
  answers7?: any;
  boldAnswers2?: string;
  boldAnswers3?: string;
  boldAnswers4?: string;
  boldAnswers5?: string;
  boldAnswers6?: string;
  boldAnswers7?: string;
  miniTitle?: string;
  miniTitle2?: string;
  miniTitle3?: string;
}

const ExpandableRow = (props: Props) => {
  const handleRow = (value) => {
    const { rowChanged } = props;

    if (rowChanged) {
      rowChanged(value);
    }
  };

  const expandRow = () => handleRow(props.index);

  const collapseRow = () => handleRow(null);

  const handleRowClick = (e) => {
    const { expanded, index } = props;

    e.stopPropagation();

    if (defined(expanded) && index !== expanded) {
      collapseRow();
      expandRow();
    } else if (expanded === null) {
      expandRow();
    } else {
      collapseRow();
    }
  };

  const { className, moreContent, title, subtitle, answers, expanded, index, miniTitle, boldAnswers } = props;

  return (
    <div
      className={classNames('expandable-row', className, {
        expanded: defined(expanded) && expanded == index,
      })}
    >
      <div className='expandable-row-top' onClick={handleRowClick}>
        <div className='title'>{title}</div>

        <div className='subtitle'>{subtitle}</div>

        {!!(moreContent || answers || miniTitle) && (
          <button
            className={classNames('arrow-button', {
              rotated: defined(expanded) && expanded == index,
            })}
          >
            <KitIcons.ArrowDownBlackIcon />
          </button>
        )}
      </div>

      {moreContent && defined(expanded) && (
        <div
          className={classNames('expandable-row-more', {
            active: defined(expanded),
          })}
        >
          {moreContent}
        </div>
      )}

      {(answers || miniTitle) && defined(expanded) && (
        <div
          className={classNames('expandable-row-more', {
            active: defined(expanded),
          })}
        >
          <p className='fw-bold mb-3'>{boldAnswers}</p>
          <p className='font-16'>{miniTitle}</p>
          {answers &&
            answers.map((answ) => (
              <ul>
                <li>{answ}</li>
              </ul>
            ))}

          <p className='fw-bold mb-3'>{props.boldAnswers2}</p>
          <p className='font-16'>{props.miniTitle2}</p>
          {props.answers2 &&
            props.answers2.map((answer) => (
              <ul>
                <li>{answer}</li>
              </ul>
            ))}

          <p className='fw-bold'>{props.miniTitle3}</p>
          <p className='fw-bold mb-3'>{props.boldAnswers3}</p>
          {props.answers3 &&
            props.answers3.map((answer) => (
              <ul>
                <li>{answer}</li>
              </ul>
            ))}

          <p className='fw-bold mb-3'>{props.boldAnswers4}</p>
          {props.answers4 &&
            props.answers4.map((answer) => (
              <ul>
                <li>{answer}</li>
              </ul>
            ))}

          <p className='fw-bold mb-3'>{props.boldAnswers5}</p>
          {props.answers5 &&
            props.answers5.map((answer) => (
              <ul>
                <li>{answer}</li>
              </ul>
            ))}

          <p className='font-weight-bold mb-3'>{props.boldAnswers6}</p>
          {props.answers6 &&
            props.answers6.map((answer) => (
              <ul>
                <li>{answer}</li>
              </ul>
            ))}

          <p className='font-weight-bold mb-3'>{props.boldAnswers7}</p>
          {props.answers7 &&
            props.answers7.map((answer) => (
              <ul>
                <li>{answer}</li>
              </ul>
            ))}
        </div>
      )}
    </div>
  );
};

function mapStateToProps(state: RootState, ownProps: any) {
  return {
    ...ownProps,
    ...state.app,
    ...state.router,
    location: state.router.location,
  };
}

function mapDispatchToProps(dispatch: Dispatch<actions.ACTION>) {
  return {};
}

export default connect(mapStateToProps, mapDispatchToProps)(ExpandableRow);
